import { h } from 'preact';
import ForwardIcon from '../../../../standard/components/common/svg/icons/icon-components/ForwardIcon';
import ADIcon from './icon-components/ADIcon';
import BackStartIcon from './icon-components/BackStartIcon';
import CheckIcon from './icon-components/CheckIcon';
import { Forward10Icon } from './icon-components/Forward10Icon';
import HDIcon from './icon-components/HDIcon';
import HeartActiveIcon from './icon-components/HeartActiveIcon';
import HeartIcon from './icon-components/HeartIcon';
import InfosIcon from './icon-components/InfosIcon';
import InfosIconActive from './icon-components/InfosIconActive';
import LeftArrowIcon from './icon-components/LeftArrowIcon';
import NextIcon from './icon-components/NextIcon';
import OutIcon from './icon-components/OutIcon';
import PauseIcon from './icon-components/PauseIcon';
import PauserollResumeDarkIcon from './icon-components/PauserollResumeDarkIcon';
import PauserollResumeIcon from './icon-components/PauserollResumeIcon';
import PlayIcon from './icon-components/PlayIcon';
import PreviousIcon from './icon-components/PreviousIcon';
import ReplayIcon from './icon-components/ReplayIcon';
import { Rewind10Icon } from './icon-components/Rewind10Icon';
import RewindIcon from './icon-components/RewindIcon';
import RightArrowIcon from './icon-components/RightArrowIcon';
import SDIcon from './icon-components/SDIcon';
import SMEIcon from './icon-components/SMEIcon';
import StopIcon from './icon-components/StopIcon';
import Text10Icon from './icon-components/Text10Icon';

export const COMMON_ICONS = (props) => ({
  play: <PlayIcon {...props} />,
  replay: <ReplayIcon {...props} />,
  pause: <PauseIcon {...props} />,
  stop: <StopIcon {...props} />,
  rewind: <RewindIcon {...props} />,
  rewind10: <Rewind10Icon {...props} />,
  forward: <ForwardIcon {...props} />,
  forward10: <Forward10Icon {...props} />,
  text10: <Text10Icon {...props} />,
  'back-to-start': <BackStartIcon {...props} />,
  next: <NextIcon {...props} />,
  'right-arrow': <RightArrowIcon {...props} />,
  'left-arrow': <LeftArrowIcon {...props} />,
  out: <OutIcon {...props} />,
  check: <CheckIcon {...props} />,
  ad: <ADIcon {...props} />,
  sme: <SMEIcon {...props} />,
  sd: <SDIcon {...props} />,
  hd: <HDIcon {...props} />,
  pauserollPlay: <PauserollResumeIcon {...props} />,
  pauserollPlayDark: <PauserollResumeDarkIcon {...props} />,
  previous: <PreviousIcon {...props} />,
  heart: <HeartIcon {...props} />,
  'heart-active': <HeartActiveIcon {...props} />,
  infos: <InfosIcon {...props} />,
  'infos-active': <InfosIconActive {...props} />
});
